import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from "primereact/progressspinner";
import { useBillingHistory } from "../hooks/queries";
import { Divider } from "primereact/divider";
import { UserRole } from "../constants";

export default function BillingHistoryDialog({
  billingId,
  visible,
  onHide,
  getStatusTag,
}) {
  const isAdmin = localStorage.getItem("isAdmin") === "true";
  const isMedicalCenter = [
    UserRole.MEDICAL_CENTER,
    UserRole.MEDICAL_CENTER_MASTER,
    UserRole.LABORATORY,
    UserRole.SUB_ADMINISTRATOR,
  ].includes(localStorage.getItem("role"));
  
  const history = useBillingHistory(billingId, {
    enabled: (isAdmin || isMedicalCenter) && visible && !!billingId,
  });

  return (
    <Dialog
      header="Historial"
      draggable={false}
      visible={visible}
      onHide={onHide}
      style={{ width: "60vw" }}
    >
      <div class="grid">
        {history.isLoading && <ProgressSpinner className="col-12" />}
        {history.data?.history.toReversed().map((item) => (
          <>
            <div className="col-2">{getStatusTag(item.status)}</div>
            <div className="col-6 flex flex-column gap-2">
              {item.author && <span>{item.author}</span>}
              <span>{new Date(item.timestamp).toLocaleString()}</span>
            </div>
            <div className="col-4 flex flex-column gap-2">
              {item.observation && (
                <>
                  <span>
                    <b>Observación:</b>
                  </span>
                  <span>{item.observation}</span>
                </>
              )}
            </div>
            <Divider className="col-12 my-0" />
          </>
        ))}
      </div>
    </Dialog>
  );
}
